<template>
  <div v-loading="loading" class="w-full">
    <div class="data-statistics">
      <title-item :right-icon="isNotBusiness" @change="handleChange">
        <div class="item">
          <img src="../imgs/data-statistics.png" alt="">
          <el-select
            v-if="isNotBusiness"
            v-model="dateMode"
            popper-class="homepage-my-wallet-select"
            class="w-[120px]"
            placeholder="请选择"
            @change="fetchData"
          >
            <el-option label="今日" value="TODAY" />
            <el-option label="本周" value="WEEK" />
            <el-option label="本月" value="MONTH" />
          </el-select>
        </div>
      </title-item>
      <div v-if="!isNotBusiness" class="not-business" :style="{ height: isSaas ? '334px' : '106px' }">
        当前不存在已分配的业务线，请联系运营开通需要的业务线
      </div>
      <div v-else class="data-statistics-list">
        <data-statistics-item v-if="isHasSplit" :data="splitList" term="splitting" />
        <data-statistics-item v-if="isHasCrowd" :data="crowdList" term="crowd" />
        <data-statistics-item v-if="isHasMatch" :data="matchList" term="match" />
        <data-statistics-item v-if="isHasBase && isSaas" :data="systemList" term="system" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import TitleItem from '../widgets/TitleItem.vue';
import DataStatisticsItem from '../widgets/DataStatisticsItem.vue';
import { ETimeRange } from '@core/main/types/home';
import { useRouter } from 'vue-router';
import { queryHomePageStatistics } from '@core/main/api';
import { ElMessage } from 'element-plus';
import { EBusinessTags, IStatisticsItem } from '@core/main/types';
import { useUserStore } from '@core/main';
import { ESystemType } from '@core/api';

const router = useRouter(); 

const { state: { identity: { systemType } } } = useUserStore();

const dateMode = ref<ETimeRange>(ETimeRange.WEEK);
const businessLineList = ref<number[]>([]);
const splitList = ref<IStatisticsItem[]>([]);
const crowdList = ref<IStatisticsItem[]>([]);
const matchList = ref<IStatisticsItem[]>([]);
const systemList = ref<IStatisticsItem[]>([]);
const loading = ref(false);

const isSaas = computed(() => systemType === ESystemType.SAAS);
const isHasCrowd = computed(() => businessLineList.value?.includes(EBusinessTags.CROWD_SOURCE));
const isHasMatch = computed(() => businessLineList.value?.includes(EBusinessTags.BROKER_LABOR));
const isHasSplit = computed(() => businessLineList.value?.includes(EBusinessTags.AIR_SPLITTING));
const isHasBase = computed(() => businessLineList.value?.includes(EBusinessTags.BASE));
const isNotBusiness = computed(() => isHasCrowd.value || isHasMatch.value || isHasSplit.value || isHasBase.value);

function handleChange() {
  router.push({ name: 'DataStatisticsManage' });
}

async function fetchData() {
  loading.value = true;

  try {
    const { businessIds, splitList: splitListData, crowdList: crowdListData, matchList: matchListData, systemList: systemListData } = await queryHomePageStatistics(dateMode.value);

    businessLineList.value = businessIds || [];
    splitList.value = splitListData || [];
    crowdList.value = crowdListData || [];
    matchList.value = matchListData || [];
    systemList.value = systemListData || [];
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

fetchData();
</script>

<style lang="scss" scoped src="../style/data-statistics.scss"></style>
